import React from 'react';
import { SimpleModalTW } from '../../tailwindComponents/modals/SimpleModalTW';
import { ErrorMessageTW } from '../../tailwindComponents/errorMessage/ErrorMessageTW';
import { Dialog } from '@headlessui/react';
import { ButtonTW, ColorlessButtonTW } from '../../tailwindComponents/buttonTW/ButtonTW';
import { checkForMutationSuccess } from '../../API/checkForMutationSuccess';
import { IClientCompanyData } from '../../ui-toolkit/orders/interfaces/IClient';
import { useUpdateClientMutation } from '../../API/clients/ClientCompanyApi';

interface IDeactivateClientCompanyModalProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  clientCompany: IClientCompanyData;
}

export const DeactivateClientCompanyModal: React.FC<IDeactivateClientCompanyModalProps> = ({
  open,
  setOpen,
  clientCompany,
}) => {
  const [updateClientCompany, { error, isLoading }] = useUpdateClientMutation();

  const handleUpdate = async () => {
    const result = await updateClientCompany({ id: clientCompany.id, isActive: false });
    if (checkForMutationSuccess(result, 'Deactivate Client Company', 'Error Deactivating Client Company')) {
      setOpen(false);
    }
  };

  return (
    <SimpleModalTW open={open} setOpen={setOpen}>
      <ErrorMessageTW rtkError={error} />
      <div className="sm:flex sm:items-start">
        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
          <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
            Deactivate Client
          </Dialog.Title>
          <div className="mt-2">
            <p className="text-sm text-gray-500">
              Are you sure you want to deactivate the client company <strong>{clientCompany.name}</strong>?
            </p>
          </div>

          <div className={'gap-4 pt-4 sm:flex sm:flex-row-reverse'}>
            <ColorlessButtonTW
              className="bg-red-500 text-white hover:bg-red-600"
              disabled={isLoading}
              onClick={handleUpdate}
            >
              Confirm
            </ColorlessButtonTW>
            <ButtonTW type="button" secondary onClick={() => setOpen(false)}>
              Cancel
            </ButtonTW>
          </div>
        </div>
      </div>
    </SimpleModalTW>
  );
};
